import React, { useState } from 'react'

export default function ContactForm() {
  const [formState, setFormState] = useState({
    fullname: '',
    email: '',
    phone: '',
    purpose: 'want to join club?',
    message: ''
  })

  const handleChange = e => {
    const { name, value } = e.target
    setFormState(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = e => {
    e.preventDefault()
    console.log('Form submitted:', formState)
    // In a real app, you would send data to a backend here
    alert(`Thank you for your message, ${formState.fullname}! We'll contact you soon.`)

    // Reset form after submission
    setFormState({
      fullname: '',
      email: '',
      phone: '',
      purpose: 'want to join club?',
      message: ''
    })
  }

  return (
    <section className='contact-section py-5'>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-6 mb-4 mb-lg-0'>
            <h2>Contact us for more queries</h2>
            <p className='pb-3'>
              We’re a nonprofit organization whose mission relies on compassionate support. If you’d
              like to help us make an impact, please reach out and connect with us today.
            </p>

            <ul className='footer-links list-unstyled'>
              <li className='mb-2'>
                <i className='fas fa-phone me-2'></i>
                <a href='tel:+15712250046'>+1 (202) 642-2746</a>
              </li>
              <li className='mb-2'>
                <i className='fas fa-envelope me-2'></i>
                <a href='mailto:admin@maverickscc.com'>admin@maverickscc.com</a>
              </li>
              <li>
                <i className='fas fa-globe me-2'></i>
                Washington, DC
              </li>
            </ul>
          </div>

          <div className='col-lg-6'>
            <form className='contact-form' onSubmit={handleSubmit}>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <label htmlFor='fullname' className='form-label'>
                    Full Name <span className='text-danger'>*</span>
                  </label>
                  <input
                    name='fullname'
                    type='text'
                    value={formState.fullname}
                    onChange={handleChange}
                    className='form-control'
                    id='fullname'
                    placeholder='Your full name'
                    required
                  />
                </div>

                <div className='col-md-6 mb-3'>
                  <label htmlFor='email' className='form-label'>
                    Email <span className='text-danger'>*</span>
                  </label>
                  <input
                    name='email'
                    type='email'
                    value={formState.email}
                    onChange={handleChange}
                    className='form-control'
                    id='email'
                    placeholder='Your email address'
                    required
                  />
                </div>
              </div>

              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <label htmlFor='phone' className='form-label'>
                    Phone
                  </label>
                  <input
                    name='phone'
                    type='tel'
                    value={formState.phone}
                    onChange={handleChange}
                    className='form-control'
                    id='phone'
                    placeholder='Your phone number'
                  />
                </div>

                <div className='col-md-6 mb-3'>
                  <label htmlFor='purpose' className='form-label'>
                    Purpose
                  </label>
                  <select
                    name='purpose'
                    className='form-select'
                    value={formState.purpose}
                    onChange={handleChange}
                    id='purpose'
                  >
                    <option value='want to join club?'>Want to join club?</option>
                    <option value='Report a problem'>Report a problem</option>
                    <option value='Other'>Other</option>
                  </select>
                </div>
              </div>

              <div className='mb-3'>
                <label htmlFor='message' className='form-label'>
                  Message <span className='text-danger'>*</span>
                </label>
                <textarea
                  name='message'
                  value={formState.message}
                  onChange={handleChange}
                  className='form-control'
                  id='message'
                  rows='4'
                  placeholder='Your message'
                  required
                />
              </div>

              <button type='submit' className='btn btn-primary w-100 py-2'>
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  )
}
